angular.module('impactx.company').controller('CustomerConfigurationCtrl', [
    '$scope',
    'dataGen',
    'BackService',
    'ToastService',
    'TranslationService',
    '$routeParams',
    'ToolbarService',
    'ConfirmationService',
    '$errorHandler',
    CustomerConfigurationCtrl]);

function CustomerConfigurationCtrl($scope, dataGen, BackService, ToastService, TranslationService,
                           $routeParams, ToolbarService, ConfirmationService, $errorHandler) {
    var ctrl = this;
    var initialContractCall = true;
    var initialVCATCall = true;

    dataGen.getData($scope, {id: $routeParams.id}, "/b2b/customerconfiguration/view").then(function () {
        defineButtons();
        $scope.trns.required = TranslationService.get("required");
    });

    this.save = function () {
        if (ctrl.validatePriceGroups()) {
            return dataGen.postAsForm({}, {data: $scope.data}, "/b2b/customerconfiguration/save").then(function () {
                ToastService.openStandardToast(TranslationService.get("saveSuccess"));
                BackService.back();
            });
        }
    };

    this.clearContractAndVCat = function () {
        if (!initialContractCall)
        {
            $scope.data.csc.selected = null;
            $scope.data.vCat.selected = null;
        }
        initialContractCall = false;
    }

    this.getPriceGroupData = function (selected) {
        if (!initialVCATCall)
        {
            $scope.data.priceGroupMappings = null;
            if (selected) {
                dataGen.getData({}, {vcatid: selected.id}, "/b2b/customerconfiguration/pricegroup").then(function (data) {
                    $scope.data.priceGroupMappings = data.data.priceGroupMappings;
                    $scope.data.targetPriceGroups = data.data.targetPriceGroups;
                });
            }
        }
        initialVCATCall = false;
    }

    this.deleteEntry = function (event) {
        ConfirmationService.showConfirmationDialog(function () {
            dataGen.postAsForm({}, {id: $routeParams.id}, "/b2b/customerconfiguration/delete").then(function () {
                ToastService.openStandardToast(TranslationService.get('deleteSuccess'));
                BackService.back();
            });
        }, event, TranslationService.get('confirmDelete'), TranslationService.get('delete'), TranslationService.get('abort'));
    }

    this.exportNow = function () {
        if (ctrl.validatePriceGroups()) {
            return dataGen.postAsForm({}, {data: $scope.data}, "/b2b/customerconfiguration/save").then(function () {
                dataGen.postAsForm({}, {id: $routeParams.id}, "/b2b/customerconfiguration/export").then(function (data) {
                    ToastService.openStandardToast(data.trns.exportSuccess);
                });
            });
        }
    }

    this.canEdit = function () {
        return $scope.data.canEdit;
    }

    this.canDelete = function () {
        return $scope.data.canEdit && $routeParams.id > 0;
    }

    this.canExport = function () {
        return $scope.data.canEdit && $routeParams.id > 0;
    }

    function defineButtons() {
        var buttonDefinition = [
            {
                label: TranslationService.get('save'),
                action: ctrl.save,
                type: 'validation',
                params: {
                    form: $scope.dialogData
                },
                condition: ctrl.canEdit,
                process: 'EditCustomerConfigurations'
            },
            {
                label: TranslationService.get('delete'),
                type: 'dialogaction',
                action: ctrl.deleteEntry,
                condition: ctrl.canDelete,
                process: 'EditCustomerConfigurations'
            },
            {
                label: $scope.trns.exportNow,
                type: 'validation',
                params: {
                    form: $scope.dialogData
                },
                action: ctrl.exportNow,
                condition: ctrl.canExport,
                process: 'EditCustomerConfigurations'
            }
        ];
        ToolbarService.setButtons(buttonDefinition);
    }

    this.validatePriceGroups = function () {
        var result = true;
        var errors = [];
        var warnings = [];
        var targetPriceGroups = {};
        var keepGoing = true;

        angular.forEach($scope.data.priceGroupMappings, function (mapping) {
            if (keepGoing) {
                var target = mapping.target.toLowerCase();
                if (target !== 'none') {
                    for (var i = 0; i < mapping.catIds.length; i++) {
                        var catId = mapping.catIds[i];
                        if (!targetPriceGroups[catId]) {
                            targetPriceGroups[catId] = [];
                        }
                        var targetPriceGroupsForCat = targetPriceGroups[catId];
                        if (targetPriceGroupsForCat.indexOf(target) !== -1) {
                            errors.push({error: $scope.trns.priceGroupsNotUnique});
                            keepGoing = false;
                            break;
                        }
                        else {
                            targetPriceGroupsForCat.push(target);
                        }
                    }
                }
            }
        });

        if (targetPriceGroups.length <= 0)
        {
            errors.push({error: $scope.trns.missingPriceGroups});
        }

        if (errors.length > 0 || warnings.length > 0) {
            $errorHandler.showErrors(errors, warnings);
            result = false;
        }

        return result;
    }
}